/** Authored dashboard/Mapping display copy; values and source headers stay unchanged. */
export const dashboardAuditArabicTranslations: Record<string, string> = {
  'Review warnings and settings': 'راجع التحذيرات والإعدادات',
  'No eligible cases': 'لا توجد حالات لحساب النسبة',
  'More employee details': 'باقي تفاصيل الموظف',
  'successfully contacted leads': ' عملاء تم التواصل معهم بنجاح',
  'leads completing demo': ' عملاء أكملوا السيشن',
  'registered leads': ' عملاء مسجلين',
  'submitted payment requests': ' طلبات دفع مقدمة',
  'eligible records': ' سجلات ينطبق عليها القياس',

  'Task {0} is reading {1} spreadsheets. The workspace updates when the realtime event arrives.': 'المهمة {0} بتقرأ {1} ملف شيت. مساحة الشغل هتتحدث لما يوصل التحديث المباشر.',
  'Task {0} is reading {1} spreadsheet. The workspace updates when the realtime event arrives.': 'المهمة {0} بتقرأ {1} ملف شيت. مساحة الشغل هتتحدث لما يوصل التحديث المباشر.',
  'No courses assigned': 'مفيش كورسات متعيّنة',
  'primary phone': 'رقم التليفون الأساسي',
  'course assignment': 'تعيين الكورس',
  'Missing headers': 'عناوين الأعمدة ناقصة',
  'Missing mapping': 'ربط الحقول ناقص',
  'No header row was discovered, so the source cannot be validated or mapped safely.': 'صف عناوين الأعمدة مش ظاهر، فمش ممكن نراجع المصدر أو نربطه بشكل صحيح.',
  'Required CRM mapping is missing: {0}.': 'ربط الحقل المطلوب ناقص: {0}.',
  'Open mapping': 'افتح الربط',
  'Invoice #{0}': 'فاتورة رقم {0}',
  'Lead display name': 'اسم العميل اللي هيظهر',
  'Primary phone number and dedupe key': 'رقم التليفون الأساسي اللي بنراجع بيه التكرار',
  'Additional contact number': 'رقم تواصل إضافي',
  'Email address': 'البريد الإلكتروني',
  'Traffic source or platform': 'مصدر العميل أو المنصة',
  'Branch or location from the source': 'الفرع أو المكان المكتوب في المصدر',
  'Lead job title': 'وظيفة العميل',
  'Actual notes from the source': 'الملاحظات المكتوبة في المصدر',
  'Import: {0}': 'الاستيراد: {0}',
  'Distribution: {0}': 'التوزيع: {0}',
  'Mapping: {0}': 'ربط الأعمدة: {0}',
  'Type: {0}': 'النوع: {0}',
  'Course: {0}': 'الكورس: {0}',
  'Data: {0}': 'البيانات: {0}',
  'Month: {0}': 'الشهر: {0}',
  'From: {0}': 'من: {0}',
  'To: {0}': 'لحد: {0}',
  'Mapping saved successfully.': 'اتحفظ ربط الأعمدة.',
  'Distribution settings saved.': 'اتحفظت إعدادات التوزيع.',
  'You have unsaved mapping changes.': 'في تعديلات على ربط الأعمدة لسه متحفظتش.',
  'Your mapping will return to the last saved version.': 'ربط الأعمدة هيرجع لآخر نسخة اتحفظت.',
  'Distribution settings were not saved': 'إعدادات التوزيع متحفظتش',
  'Import started for {0}. The summary will refresh when it finishes.': 'بدأ استيراد {0}. الملخص هيتحدث لما يخلص.',
  'Retried {0} rows. Imported {1}, skipped {2}, failed {3}.': 'اتعاد محاولة {0} صف. اتستورد {1}، واتعدّى {2}، وفشل {3}.',
  '{0} leads assigned to {1}. {2} available now{3}.': 'اتوزع {0} ليد على {1}. المتاح دلوقتي {2}{3}.',
  ', {0} waiting for capacity': '، و{0} مستنيين مساحة',
  'Manual refill failed': 'إرسال الليدز الإضافية فشل',
  'Unable to send extra leads': 'مش قادرين نبعت الليدز الإضافية',
  'Unable to start sheet pull': 'مش قادرين نبدأ استيراد الشيت',
  'Unable to retry problem rows': 'مش قادرين نعيد محاولة الصفوف اللي فيها مشكلة',
  'Unable to save distribution settings': 'مش قادرين نحفظ إعدادات التوزيع',
  'instapay': 'إنستاباي',
  'cash': 'كاش',
  'bank_transfer': 'تحويل بنكي',
  'wallet': 'محفظة',
  'Monthly target': 'تارجت الشهر',
  'Unassigned leads are eligible for distribution again{0}.': 'الليدز اللي لسه متوزعتش ينفع تتوزع تاني{0}.',
  ' ({0} assigned)': ' (اتوزع {0})',
  '{0} confirmed sales': 'المبيعات المؤكدة لـ{0}',
  '{0} first-time paid customers': 'العملاء اللي دفعوا أول مرة مع {0}',
  '{0} currently Paid pipeline leads': 'عملاء {0} الموجودين دلوقتي في مرحلة مدفوع',
  '{0} registered cohort': 'العملاء اللي سجلوا مع {0}',
  '{0} pending payments': 'المدفوعات اللي مستنية مراجعة عند {0}',
  '{0} overdue follow-ups': 'المتابعات المتأخرة عند {0}',
  '{0} successfully contacted cohort': 'العملاء اللي {0} اتواصل معاهم بنجاح',
  '{0} assigned target': 'التارجت الموزع على {0}',
  '{0} achievement inputs': 'تفاصيل تحقيق تارجت {0}',
  'Confirmed sales — selected period': 'المبيعات المؤكدة — الفترة المختارة',
  'Confirmed sales — previous period': 'المبيعات المؤكدة — الفترة السابقة',
  'Gross eligible collection — selected period': 'التحصيل المؤهل قبل الخصم — الفترة المختارة',
  'Gross eligible collection — previous period': 'التحصيل المؤهل قبل الخصم — الفترة السابقة',
  'Confirmed sales transactions — selected period': 'عمليات البيع المؤكدة — الفترة المختارة',
  'Unique confirmed buyers': 'عدد العملاء المشترين المؤكدين',
  'Commission on actual collected receipts': 'عمولة الإيصالات اللي اتحصلت فعلًا',
  'Employee collection': 'تحصيل الموظف',
  'Assigned target': 'التارجت الموزع',
  'Achievement inputs': 'تفاصيل تحقيق التارجت',
  'Leads registered in the selected period': 'العملاء اللي سجلوا في الفترة المختارة',
  'Registered for more than 48 hours': 'عملاء مسجلين من أكتر من ٤٨ ساعة',
  'Completed demos without next action': 'سيشنز خلصت من غير خطوة تالية',
  'Unsuccessful demos without reschedule': 'سيشنز غير مكتملة من غير معاد جديد',
  'Behind expected progress to date': 'متأخرين عن التقدم المتوقع لحد النهارده',
  'Use Pull Now to import; new valid leads stay Unassigned until you resume distribution.': 'استخدم استيراد دلوقتي؛ الليدز الجديدة السليمة هتفضل من غير موظف لحد ما تكمل التوزيع.',
  'Stay': 'كمّل التعديل',
  '<24h': 'أقل من ٢٤ ساعة',
  '24-48h': 'من ٢٤ لـ٤٨ ساعة',
  '>48h': 'أكتر من ٤٨ ساعة',
  'Figures changed. Refresh the dashboard to reconcile the new snapshot.': 'الأرقام اتغيرت. حدّث الداشبورد عشان تعرض البيانات الجديدة.',
  'Could not load details. Try refreshing.': 'مش قادرين نحمّل التفاصيل. جرّب التحديث.',
  '↑ {0}% vs previous period': '↑ {0}٪ عن الفترة السابقة',
  '↓ {0}% vs previous period': '↓ {0}٪ عن الفترة السابقة',
  'No change vs previous period': 'مفيش تغيير عن الفترة السابقة',
  'Previous period was zero': 'الفترة السابقة كانت صفر',
  'Previous period was zero · +{0} EGP': 'الفترة السابقة كانت صفر · زيادة {0} ج.م.',
  'Registered without payment for more than 48h': 'عملاء سجلوا من أكتر من ٤٨ ساعة ولسه مدفعوش',
  'Immediate action required.': 'محتاج إجراء دلوقتي.',
  'Lead → Paid': 'من عميل محتمل لمدفوع',
  'Demo → Registered': 'من سيشن لتسجيل',
  'Registered → Payment': 'من تسجيل لدفع',
  'Payment confirmation': 'تأكيد الدفع',
  'Confirmed sales': 'المبيعات المؤكدة',
  'Sources with a live CRM connection': 'مصادر متصلة بالنظام دلوقتي',
  'Sources need mapping': 'مصادر محتاجة ربط الأعمدة',
  'Sources paused': 'مصادر متوقفة',
  '{0} distributed': 'اتوزع {0}',
  'Google Sheet': 'شيت جوجل',
  'Manual Upload': 'رفع يدوي',
  'New leads without action': 'عملاء جدد من غير إجراء',
  'Follow-ups due later today': 'متابعات ميعادها باقي النهارده',
  'Open leads without a next action date': 'عملاء مفتوحين من غير ميعاد للخطوة الجاية',
  'Registered — waiting for payment': 'التسجيل مكتمل — مستني الدفع',
  'Payments awaiting approval': 'مدفوعات مستنية الموافقة',
  'Successfully contacted lead cohort': 'العملاء اللي اتواصلنا معاهم بنجاح',
  'Completed demo cohort': 'العملاء اللي خلصوا السيشن',
  'Registered lead cohort': 'العملاء اللي سجلوا',
  'Submitted payment cohort': 'العملاء اللي بعتوا الدفع',
  'Scheduled or sent demo cohort': 'العملاء اللي اتحجزت لهم السيشن أو اتبعتت لهم',
  'Employees below 50% of target': 'موظفين محققوش نص التارجت',
  'Registered waiting {0}': 'عملاء مسجلين مستنيين الدفع {0}',
  'Payment pending {0}': 'دفع مستني المراجعة {0}',
  'Open the customer list and assign an immediate action.': 'افتح قائمة العملاء وحدد إجراء دلوقتي.',
  'Demo completed without a next action': 'السيشن خلصت من غير خطوة تالية',
  'Attended or viewed demos must have a recorded next step.': 'السيشن اللي العميل حضرها أو شافها لازم يتسجل بعدها خطوة تالية.',
  'Follow-up date is already in the past.': 'ميعاد المتابعة فات.',
  'No-show / not-viewed demos without reschedule': 'سيشنز العميل محضرهاش أو مشافهاش من غير معاد جديد',
  'Choose a follow-up or a new demo time.': 'حدد متابعة أو ميعاد جديد للسيشن.',
  'Payments awaiting Marketing / Reception approval': 'مدفوعات مستنية موافقة التسويق أو الريسبشن',
  '{0} EGP pending; <24h {1}, 24-48h {2}, >48h {3}.': '{0} ج.م. مستنية مراجعة؛ أقل من ٢٤ ساعة: {1}، من ٢٤ لـ٤٨ ساعة: {2}، أكتر من ٤٨ ساعة: {3}.',
  'New / Old Data leads without a first action': 'عملاء من الداتا الجديدة أو القديمة من غير أول إجراء',
  'Live queue; the selected period does not hide older untouched leads.': 'قائمة الشغل الحالية؛ الفترة المختارة مبتخفيش العملاء الأقدم اللي لسه متعملهمش إجراء.',
  'Employees below 50% achievement': 'موظفين محققوش نص التارجت',
  'Target comparison uses Reception-confirmed total sales.': 'مقارنة التارجت حسب إجمالي المبيعات المؤكدة من الريسبشن.',
  'Leads in {0}': 'عملاء مرحلة {0}',
  'Leads for {0}': 'عملاء {0}',
};
export const dashboardAuditEnglishTranslations: Record<string, string> = Object.fromEntries(Object.entries(dashboardAuditArabicTranslations).map(([en, ar]) => [ar, en]));
